/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A question from a competitor or a listed-school admin: plain text, 10 to 2000 characters.
 * @export
 * @interface EventQuestionCreate
 */
export interface EventQuestionCreate {
    /**
     * 
     * @type {string}
     * @memberof EventQuestionCreate
     */
    text: string;
}

/**
 * Check if a given object implements the EventQuestionCreate interface.
 */
export function instanceOfEventQuestionCreate(value: object): value is EventQuestionCreate {
    if (!('text' in value) || value['text'] === undefined) return false;
    return true;
}

export function EventQuestionCreateFromJSON(json: any): EventQuestionCreate {
    return EventQuestionCreateFromJSONTyped(json, false);
}

export function EventQuestionCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventQuestionCreate {
    if (json == null) {
        return json;
    }
    return {
        
        'text': json['text'],
    };
}

export function EventQuestionCreateToJSON(json: any): EventQuestionCreate {
    return EventQuestionCreateToJSONTyped(json, false);
}

export function EventQuestionCreateToJSONTyped(value?: EventQuestionCreate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'text': value['text'],
    };
}

